exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.v-toolbar__content {\n  padding-left: 0px;\n}\n", "", {"version":3,"sources":["/Users/karsten/Projects/VBus.net/server/src/client/components/Navigation/Bottom.vue"],"names":[],"mappings":";AACA;EACE,kBAAkB;CACnB","file":"Bottom.vue","sourcesContent":["\n.v-toolbar__content {\n  padding-left: 0px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-38226abf","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/client/components/Navigation/Bottom.vue
// module id = vWoo
// module chunks = 48